import React from 'react';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, number } from 'prop-types';
import TicketsListItem from './TicketsListItem';

const propTypes = {
  tickets: array.isRequired,
  total: number.isRequired,
};

const defaultProps = {
  tickets: [],
  total: 0,
};

const TicketsList = ({ tickets, tableSettings }) => (
  <Table className="tickets-list no-margin" bordered responsive>
    <thead>
      <tr>
        {tableSettings.id && <th>
          <FormattedMessage id="tickets.id" defaultMessage="ID" />
        </th>}
        {tableSettings.created && <th>
          <FormattedMessage id="tickets.created.theme_3" defaultMessage="Created" />
        </th>}
        {tableSettings.title && <th>
          <FormattedMessage id="tickets.title.theme_3" defaultMessage="Title" />
        </th>}
        {tableSettings.status && <th>
          <FormattedMessage id="tickets.status" defaultMessage="Status" />
        </th>}
        {tableSettings.answer && <th>
          <FormattedMessage id="tickets.answers" defaultMessage="Answers" />
        </th>}
      </tr>
    </thead>
    <tbody>
      {tickets.length > 0 &&
        tickets.map(ticket => <TicketsListItem tableSettings={tableSettings} key={ticket.id} ticket={ticket} />)}
    </tbody>
  </Table>
);

TicketsList.propTypes = propTypes;
TicketsList.defaultProps = defaultProps;

export default TicketsList;
